(function () {
  const root = document.querySelector('.rebx-collection-search');
  const input = document.getElementById('RebxCollectionSearch');
  if (!root || !input) return;

  const clearButton = root.querySelector('.rebx-collection-search__clear');
  const handle = input.dataset.collectionHandle;
  const collectionUrl = input.dataset.collectionUrl || `/collections/${handle}`;
  const cardCache = new Map();
  let catalog = null;
  let catalogPromise = null;
  let snapshot = null;
  let snapshotCountDesktop = null;
  let snapshotCount = null;
  let token = 0;
  let timer = null;

  function grid() {
    return document.getElementById('product-grid');
  }

  function sectionId() {
    return grid()?.dataset.id || '';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function money(amount) {
    const number = Number(amount);
    if (!Number.isFinite(number)) return '';
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(number);
  }

  function conditionLabel(tags) {
    const list = tags || [];
    const grades = ['Refurbished - Excellent', 'Refurbished - Very Good', 'Refurbished - Good', 'Refurbished - Fair'];
    for (const grade of grades) {
      if (list.some((tag) => tag.toLowerCase() === grade.toLowerCase())) return grade;
    }
    if (list.some((tag) => /acceptable/i.test(tag))) return 'Fair - Refurbished';
    if (list.some((tag) => tag.toLowerCase() === 'new')) return 'New';
    if (list.some((tag) => /open box/i.test(tag))) return 'Open Box';
    return '';
  }

  function imageSrc(src) {
    if (!src) return '';
    const url = src.startsWith('//') ? `https:${src}` : src;
    return `${url}${url.includes('?') ? '&' : '?'}width=533`;
  }

  function indexCards(scope) {
    scope?.querySelectorAll('.collection-product-card').forEach((card) => {
      const productHandle = card.querySelector('[data-product]')?.dataset.product;
      if (productHandle) cardCache.set(productHandle, card.outerHTML);
    });
  }

  function captureSnapshot() {
    const productGrid = grid();
    if (!productGrid || snapshot) return;
    indexCards(productGrid);
    snapshot = productGrid.innerHTML;
    snapshotCountDesktop = document.getElementById('ProductCountDesktop')?.innerHTML || '';
    snapshotCount = document.getElementById('ProductCount')?.innerHTML || '';
  }

  function setCount(text) {
    const desktop = document.getElementById('ProductCountDesktop');
    const mobile = document.getElementById('ProductCount');
    if (desktop) desktop.textContent = text;
    if (mobile) mobile.textContent = text;
  }

  function restore() {
    const productGrid = grid();
    if (productGrid && snapshot != null) productGrid.innerHTML = snapshot;
    if (snapshotCountDesktop) {
      const desktop = document.getElementById('ProductCountDesktop');
      if (desktop) desktop.innerHTML = snapshotCountDesktop;
    }
    if (snapshotCount) {
      const mobile = document.getElementById('ProductCount');
      if (mobile) mobile.innerHTML = snapshotCount;
    }
    document.documentElement.classList.remove('rebx-collection-search-active');
  }

  function matches(product, query) {
    const words = query.toLowerCase().split(/\s+/).filter(Boolean);
    if (!words.length) return true;
    const haystack = [
      product.title,
      product.vendor,
      product.product_type,
      ...(product.tags || []),
      ...(product.variants || []).flatMap((variant) => [variant.title, variant.sku, variant.barcode])
    ].join(' ').toLowerCase();
    return words.every((word) => haystack.includes(word));
  }

  function fallbackCard(product) {
    const variant = (product.variants || []).find((item) => item.available) || product.variants?.[0] || {};
    const condition = conditionLabel(product.tags);
    const price = money(variant.price);
    const compare = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
      ? money(variant.compare_at_price)
      : '';
    const src = imageSrc(product.images?.[0]?.src);
    const url = `/products/${product.handle}`;
    return `<li class="collection-product-card">
      <div class="card-wrapper card-wrapper--collection" data-product="${escapeHtml(product.handle)}">
        <div class="card card--product">
          <div class="card__inner">
            <div class="media media--transparent media--uniform-thumb media--square" style="padding-bottom: 100%;">
              ${src ? `<img src="${escapeHtml(src)}" alt="${escapeHtml(product.title)}" width="533" height="533" loading="lazy" style="object-fit: contain;">` : ''}
            </div>
          </div>
        </div>
        <div class="card-information">
          <div class="card-information__wrapper">
            <h3 class="card__title h5"><a class="full-unstyled-link" href="${url}">${escapeHtml(product.title)}</a></h3>
            ${condition ? `<p class="card__condition-line${/new|open box/i.test(condition) ? '' : ' card__condition-line--refurb'}">${/new|open box/i.test(condition) ? '' : '<span class="card__condition-line__icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'}<span>${escapeHtml(condition)}</span></p>` : ''}
            <div class="card__price-block">
              <div class="card-price">
                <div class="card-price__main"><span class="card-price__current">${escapeHtml(price)}</span></div>
                <p class="card-price__meta${compare ? '' : ' card-price__meta--empty'}">${compare ? `<span class="card-price__was"><s>${escapeHtml(compare)}</s></span>` : ''}</p>
              </div>
              <div class="card-tradein" data-tradein-card data-price-cents="${Math.round(Number(variant.price) * 100)}" data-title="${escapeHtml(product.title)}">
                <div class="card-tradein__main">
                  <span class="card-tradein__credit" data-tradein-credit></span>
                  <span class="card-tradein__kind">store credit</span>
                </div>
                <p class="card-tradein__cash"><span data-tradein-cash></span> cash</p>
              </div>
            </div>
          </div>
        </div>
        <a class="link link--overlay card-wrapper__link--overlay" href="${url}" aria-label="${escapeHtml(product.title)}"></a>
      </div>
    </li>`;
  }

  async function loadCatalog() {
    if (catalog) return catalog;
    if (!catalogPromise) {
      catalogPromise = (async () => {
        const products = [];
        for (let page = 1; page <= 8; page += 1) {
          const response = await fetch(`${collectionUrl}/products.json?limit=250&page=${page}`);
          if (!response.ok) break;
          const data = await response.json();
          const batch = data.products || [];
          products.push(...batch);
          if (batch.length < 250) break;
        }
        catalog = products;
        return products;
      })().catch(() => {
        catalogPromise = null;
        return [];
      });
    }
    return catalogPromise;
  }

  async function loadPage(page) {
    const id = sectionId();
    if (!id) return 1;
    const response = await fetch(`${collectionUrl}?page=${page}&section_id=${encodeURIComponent(id)}`);
    if (!response.ok) return page;
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    indexCards(parsed);
    const total = Number(parsed.querySelector('[data-total-pages]')?.value || page);
    return total;
  }

  async function ensureCards(handles) {
    captureSnapshot();
    indexCards(new DOMParser().parseFromString(`<ul>${snapshot || ''}</ul>`, 'text/html'));
    let page = 1;
    let total = 1;
    while (handles.some((item) => !cardCache.has(item)) && page <= total && page <= 20) {
      total = await loadPage(page);
      page += 1;
    }
  }

  function renderMatches(products) {
    const productGrid = grid();
    if (!productGrid) return;
    if (!products.length) {
      const term = input.value.trim();
      productGrid.innerHTML = `<li class="rebx-collection-search-empty">No products in this collection match “${escapeHtml(term)}”.</li>`;
      return;
    }
    productGrid.innerHTML = products.map((product) => cardCache.get(product.handle) || fallbackCard(product)).join('');
  }

  async function apply() {
    const query = input.value.trim();
    clearButton.hidden = query.length === 0;
    const current = ++token;
    if (!query) {
      restore();
      return;
    }

    captureSnapshot();
    document.documentElement.classList.add('rebx-collection-search-active');
    setCount('Searching this collection…');

    const products = await loadCatalog();
    if (current !== token) return;
    const found = products.filter((product) => matches(product, query));
    await ensureCards(found.map((product) => product.handle));
    if (current !== token) return;
    renderMatches(found);
    const label = found.length === 1 ? 'product' : 'products';
    setCount(`Showing ${found.length} of ${products.length} ${label}`);
  }

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, 250);
  });

  input.addEventListener('search', () => {
    window.clearTimeout(timer);
    apply();
  });

  clearButton.addEventListener('click', () => {
    input.value = '';
    input.focus();
    apply();
  });

  window.RebxCollectionSearch = {
    onGridReplaced() {
      snapshot = null;
      snapshotCountDesktop = null;
      snapshotCount = null;
      cardCache.clear();
      if (input.value.trim()) apply();
    }
  };
})();
